import useSWR from 'swr'
import Image from 'next/legacy/image'
import { BlockComponent } from 'lib'
import { getRootProducts } from 'services/ContentfulService/hooks/products'
import { TagsWrapper } from '../components/Layout/styles'
import { CardLayout } from '../components/Layout'
import { Box } from 'components/layout/primitives'
import { LinkButton } from 'ui/inputs/Button/LinkButton'

export const EmptyState: BlockComponent = () => {
	const { data } = useSWR('/content/products/root', getRootProducts)

	return CardLayout({
		title: 'Your favorite articles will appear here',
		graphic: <Image src="/images/illustrations/favorite-articles.svg" width="90" height="102" alt="" />,
		body: (
			<div>
				<p>Read articles to become better informed on personal finance, terminology, and more.</p>
				<TagsWrapper>
					{data &&
						data.map(option => (
							<Box key={option.name} space={'smaller'}>
								<LinkButton size="small" key={option.name} href={option.relativeLearnPath}>
									{option.name}
								</LinkButton>
							</Box>
						))}
				</TagsWrapper>
			</div>
		)
	})
}
